import { queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../core/api/queries";

export default createQueryGroup(({ api }) => {
  return {
    certificationsSettings: () =>
      queryOptions({
        queryKey: ["agency-certifications-settings"],
        queryFn: () => api.get("./certifications_settings", {}),
      }),
  };
});
